export default __webpack_public_path__ + "assets/png/63be892b001e984280fcbe84fa058bca.png";